import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-16-drop-down (1)",
  "use": "icon-icon-16-drop-down (1)-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-16-drop-down (1)\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M13.654 5.5a1 1 0 0 1 0 1.414L8.35 12.218a.5.5 0 0 1-.707 0L2.34 6.914A1 1 0 0 1 3.754 5.5l4.242 4.242L12.239 5.5a1 1 0 0 1 1.415 0z\" fill=\"#7F8596\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol